import { StateCreator } from 'zustand';
import { AuthStore, AuthUtils } from '../types';

export const createUtilsSlice: StateCreator<AuthStore, [], [], AuthUtils> = (set) => ({
    reset: () => set({ data: null, loading: false, error: null }),
});
